import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const ViolationTrend = ({ data }) => {
  let { width } = useWindowDimensions();
  const chartData = {
    series: [
      {
        name: "Violation",
        data: data?.map((item) => item?.violations),
      },
    ],
    options: {
      chart: {
        type: "area",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false, 
        },
        selection: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
        width: 2,
        show: true
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 0.7,
          opacityFrom: 0.5,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
      grid: {
        row: {
          colors: ['transparent', 'transparent'], 
          opacity: 1,
        },
      },
      markers: {
        size: 5,
        colors: "#ca373c",
      },

      xaxis: {
        categories: data?.map((item) => item?.label),
      },
      colors: ['#ca373c'],
    },
  };

  return (
    <>
      <div id="chart" className="pt-1">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="area"
          height={(width > 1400 && width < 1700) ? 253 : width >= 1700 ? 300 : 210}
        />
      </div>
    </>
  );
};

export default ViolationTrend;
